import { render } from "./SoftHard.vue?vue&type=template&id=f7ebdc96&scoped=true"
import script from "./SoftHard.vue?vue&type=script&lang=js"
export * from "./SoftHard.vue?vue&type=script&lang=js"

import "./SoftHard.vue?vue&type=style&index=0&id=f7ebdc96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7ebdc96"]])

export default __exports__